export const SET_ORDER = 'SET_ORDER'
export const SET_IDS = 'SET_IDS'

const state = {
  property: '',
  direction: 'asc',
  ids: []
}

const mutations = {
  [SET_ORDER] (state, { property, direction }) {
    state.property = property
    state.direction = direction
  },
  [SET_IDS] (state, ids) {
    state.ids = ids
  }
}

function createSort (overrides) {
  return {
    namespaced: true,
    state: {...state, ...overrides},
    mutations
  }
}

export function registerSort (rootStore, collectionModuleName, overrides) {
  rootStore.registerModule([collectionModuleName, 'sort'], createSort(overrides))
}



// WEBPACK FOOTER //
// ./src/store/modules/sort.js